import { render, staticRenderFns } from "./StocksInventory.vue?vue&type=template&id=31ab40cc"
import script from "./StocksInventory.vue?vue&type=script&lang=js"
export * from "./StocksInventory.vue?vue&type=script&lang=js"
import style0 from "./StocksInventory.vue?vue&type=style&index=0&id=31ab40cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports